// extracted by mini-css-extract-plugin
module.exports = {"sidebarWidgetsContainer":"SidebarWidgets_sidebarWidgetsContainer__26xEZ","title":"SidebarWidgets_title__cDPNY","item":"SidebarWidgets_item__1xRi1"};